var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltipListeners = ref.on;
return [_c('div',_vm._g({},tooltipListeners),[_c('v-icon',{staticClass:"mr-1"},[_vm._v("eva-checkmark-circle-2")]),_c('span',[_vm._v("Salvo "+_vm._s(_vm.lastSaveTime)+".")])],1)]}}])},[_vm._v(" Salvo em "+_vm._s(_vm.formattedSavedAt)+". ")])}
var staticRenderFns = []

export { render, staticRenderFns }